import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const sfFinancialDistrictOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'san-francisco',
  neighborhoodSlug: 'financial-district',
  neighborhoodDisplayName: 'Financial District',
  metroDisplayName: 'San Francisco',
  totalCodiClientsInNeighborhood: 29,
  whereFromStreetsToLandmark:
    'from the buildings along Battery St, Bush St, and Grant Ave to the clusters near Salesforce Tower',
  whereTeamStreets: 'Battery St, Bush St, Grant Ave, Kearny St',
  clientDescriptor: 'a small team professional services firm near Montgomery St',
  counts: {
    managedCleaningOffices: 18,
    managedPantryOffices: 29,
    managedInternetOffices: 29,
    managedFurnitureOffices: 18,
    managedOfficeAssistantOffices: 18,
    managedDeepCleaningOffices: 10,
    managedCarpetCleaningOffices: 8,
    managedWindowCleaningOffices: 7,
    managedGlassCleaningOffices: 12,
    managedWasteRecyclingOffices: 11,
    managedPantryInventoryOffices: 20,
    managedCoffeeServiceOffices: 16,
    managedWaterServiceOffices: 15,
    managedTeamLunchOffices: 8,
    managedBreakfastCateringOffices: 6,
    managedIndividualMealsOffices: 5,
    managedAdHocCateringOffices: 9,
    managedHappyHourOffices: 7,
    managedConferenceRoomAvOffices: 11,
    managedNetworkInstallationOffices: 20,
    managedNetworkManagementOffices: 14,
    managedCableManagementOffices: 9,
    managedRoomBookingOffices: 8,
    managedPrintingSetupOffices: 13,
    managedInteriorDesignOffices: 10,
    managedOfficeMuralsOffices: 4,
    managedOfficePaintingOffices: 6,
    managedGlassFrostingOffices: 8,
    managedOfficeSignageOffices: 6,
    managedCareRoomOffices: 4,
    managedFurnitureAssemblyOffices: 13,
    managedLayoutChangeOffices: 8,
    managedOfficePlantsOffices: 11,
    managedKeylessAccessOffices: 13,
    managedAlarmSystemsOffices: 7,
    managedSecurityCamerasOffices: 11,
    managedKeypadOffices: 9,
    managedLockboxOffices: 5,
    managedVisitorManagementOffices: 8,
    managedBusinessInsuranceOffices: 10,
    managedElectricalServicesOffices: 6,
    managedHvacOffices: 5,
    managedPlumbingOffices: 4,
    managedPestControlOffices: 4,
    managedOfficeMovingOffices: 5,
    managedMountingInstallationOffices: 7
  },
  quotes: {
    cleaning: 'Our coordinator left and we had no backup. Codi just stepped in and handled it.',
    pantryRestocking: 'The pantry was always running out. Since Codi took it over, it just stays stocked.',
    internet: 'Codi coordinated the vendor walkthrough and the whole install \u2014 we just showed up.',
    officeAssistant: 'Building staff drop-ins, packages, pantry restock \u2014 it all needs a person on site.',
    officeFurniture: 'We needed the space set up fast. Codi had it done before we moved in.',
    deepCleaning: 'End-of-quarter deep cleans used to eat up half a day of coordination. Codi owns it now.',
    carpetCleaning: 'Professional services clients notice everything. Codi keeps the carpets in shape.',
    windowCleaning: 'Financial District high-rise windows need regular attention. Codi handles the vendor.',
    glassConferenceRoom: 'Glass boards and walls in client-facing rooms need to be spotless. Codi ensures that.',
    wasteRecycling: 'Codi manages our waste and recycling pickup so we never have to think about it.',
    pantryInventory:
      'We had a dedicated person just managing pantry stock. Codi automated it and that person does real work now.',
    coffeeService:
      'Coffee is the one thing our team will complain about. Codi makes sure the machine is always running and stocked.',
    waterService:
      'Filtered water is a basic expectation in a Financial District office. Codi handles the whole setup and restocking.',
    teamLunch:
      'Weekly team lunch used to take an hour to coordinate. Now Codi handles the vendor, delivery, and setup.',
    breakfastCatering:
      'We bring in breakfast for the team on pitch days. Codi has it ready every time without any reminders.',
    individualMeals:
      'Daily meal program for the team. Codi manages the vendor relationship and makes sure delivery runs on time.',
    adHocCatering: 'Catering for client meetings in the Financial District can\u2019t fail. Codi delivers every time.',
    happyHour: 'Our Friday wind-down ritual. Codi handles the drinks order and setup so nobody has to think about it.',
    conferenceRoomAv:
      'Client presentations in the Financial District need reliable A/V. Codi set it up right the first time.',
    networkInstallation:
      'Moving to a new Financial District floor meant a full network install. Codi managed the whole thing.',
    networkManagement: 'Codi monitors our managed network 24/7. Issues get resolved before they hit the team.',
    cableManagement: 'Trading floors have a lot of cables. Codi organized every run and labeled everything cleanly.',
    roomBooking:
      'Eight conference rooms, constant double-booking. Codi deployed room tablets and the problem disappeared.',
    printingSetup: 'Codi handled the printer rollout across three floors. Drivers, network config, everything sorted.',
    interiorDesign:
      'We needed a space that matched the brand before client tours started. Codi managed design, procurement, and install.',
    officeMurals: 'We wanted the lobby to make a statement. Codi sourced an artist and handled the whole installation.',
    officePainting:
      'Refreshing the walls before a restack. Codi coordinated after-hours painters and it was done without disrupting the team.',
    glassFrosting:
      'Client-facing conference rooms needed privacy. Codi measured, ordered, and installed frosted film in a single visit.',
    officeSignage:
      'Professional signage in a Financial District building matters. Codi designed and installed ours in under a week.',
    careRoom:
      'We needed a private care room for nursing staff. Codi furnished it, added a privacy curtain, and it was ready in a day.',
    furnitureAssembly:
      'We relocated 60 people across three floors. Codi had assembly crews in and everything set up over one weekend.',
    layoutChange:
      'Restructuring the floor plan took a weekend. Codi moved every desk, rerouted cables, and had us back online by Monday.',
    officePlants:
      'A financial firm with no greenery felt cold. Codi brought in a curated plant program and maintains it monthly.',
    keylessAccess:
      'Financial District building required keyless access before move-in. Codi handled the install, credential setup, and ongoing management.',
    alarmSystems:
      'Monitored alarm system was a lease requirement. Codi sourced the vendor, managed building coordination, and handles testing.',
    securityCameras:
      'Client-facing offices need security coverage. Codi installed cameras at entry points and manages remote monitoring.',
    keypads:
      'Multiple entry points needed keypad access. Codi installed and manages all codes for the Financial District office.',
    lockboxes:
      'After-hours vendor access is frequent in this building. Codi manages lockbox placement and access coordination.',
    visitorManagement:
      'Professional services clients expect a polished check-in. Codi deployed visitor management with badge printing and compliance logging.',
    businessInsurance:
      'Financial District leases require frequent COI updates. Codi manages our business insurance and certificate distribution.',
    electricalServices:
      'We needed dedicated circuits for server equipment. Codi coordinated a licensed electrician with the building and got it permitted and installed.',
    hvac: 'Our Financial District office runs hot in summer. Codi manages HVAC service calls and coordinates with building engineering for shared system issues.',
    plumbing:
      'A sink fixture failed in the kitchen before a client event. Codi had a plumber there in two hours and the problem fixed before anyone arrived.',
    pestControl:
      'High foot traffic in Financial District buildings creates pest risk. Codi schedules quarterly treatments and keeps the office compliant.',
    officeMoving:
      'Relocating a professional services firm takes precision. Codi managed our Financial District move \u2014 crew, building access, and equipment handling.',
    mountingInstallation:
      'Client rooms needed proper TV and whiteboard setups. Codi mounted everything, ran cables through walls, and had it done in one visit.'
  },
  officeAssistant: {}
});
